module.exports = __webpack_public_path__ + "img/hiking_1413_6.04983400.jpg";